import { Box, styled, Typography } from "@mui/material";

const baseDiodStyle = {
	width: 10,
	height: 10,
	borderRadius: "50%",
	cursor: "pointer",
};

export const GreenDiod = styled(Box, {
	shouldForwardProp: (prop) => prop !== "pulsing",
})<{ pulsing?: boolean }>(({ pulsing }) => ({
	...baseDiodStyle,
	backgroundColor: "#4caf50",
	boxShadow: "0 0 0 rgba(76, 175, 80, 0.4)",
	animation: pulsing ? "pulseGreen 1.5s infinite" : "none",
	"@keyframes pulseGreen": {
		"0%": {
			transform: "scale(0.95)",
			boxShadow: "0 0 0 0 rgba(76, 175, 80, 0.4)",
		},
		"70%": {
			transform: "scale(1)",
			boxShadow: "0 0 0 6px rgba(76, 175, 80, 0)",
		},
		"100%": {
			transform: "scale(0.95)",
			boxShadow: "0 0 0 0 rgba(76, 175, 80, 0)",
		},
	},
}));

export const OrangeDiod = styled(Box, {
	shouldForwardProp: (prop) => prop !== "pulsing",
})<{ pulsing?: boolean }>(({ pulsing }) => ({
	...baseDiodStyle,
	backgroundColor: "#f5bd00",
	boxShadow: "0 0 0 rgba(245, 189, 0, 0.4)",
	animation: pulsing ? "pulseYellow 1.5s infinite" : "none",
	"@keyframes pulseYellow": {
		"0%": {
			transform: "scale(0.95)",
			boxShadow: "0 0 0 0 rgba(245, 189, 0, 0.4)",
		},
		"70%": {
			transform: "scale(1)",
			boxShadow: "0 0 0 6px rgba(245, 189, 0, 0)",
		},
		"100%": {
			transform: "scale(0.95)",
			boxShadow: "0 0 0 0 rgba(245, 189, 0, 0)",
		},
	},
}));

export const RedDiod = styled(Box, {
	shouldForwardProp: (prop) => prop !== "pulsing",
})<{ pulsing?: boolean }>(({ pulsing }) => ({
	...baseDiodStyle,
	backgroundColor: "#db6969",
	boxShadow: "0 0 0 rgba(219, 105, 105, 0.4)",
	animation: pulsing ? "pulseRed 1.5s infinite" : "none",
	"@keyframes pulseRed": {
		"0%": {
			transform: "scale(0.95)",
			boxShadow: "0 0 0 0 rgba(219, 105, 105, 0.4)",
		},
		"70%": {
			transform: "scale(1)",
			boxShadow: "0 0 0 6px rgba(219, 105, 105, 0)",
		},
		"100%": {
			transform: "scale(0.95)",
			boxShadow: "0 0 0 0 rgba(219, 105, 105, 0)",
		},
	},
}));

export const GrayDiod = styled(Box, {
	shouldForwardProp: (prop) => prop !== "pulsing",
})<{ pulsing?: boolean }>(({ pulsing }) => ({
	...baseDiodStyle,
	backgroundColor: "#bdbdbd", // нейтрально-серый
	boxShadow: "0 0 0 rgba(189, 189, 189, 0.4)",
	animation: pulsing ? "pulseGray 1.5s infinite" : "none",
	"@keyframes pulseGray": {
		"0%": { transform: "scale(0.95)", boxShadow: "0 0 0 0 rgba(189,189,189,0.4)" },
		"70%": { transform: "scale(1)", boxShadow: "0 0 0 6px rgba(189,189,189,0)" },
		"100%": { transform: "scale(0.95)", boxShadow: "0 0 0 0 rgba(189,189,189,0)" },
	},
}));

export const TooltipBackground = styled(Box)(() => ({
	display: "flex",
	flexDirection: "column",
	flexWrap: "wrap",
	backgroundColor: "#fff",
	padding: "0",
}));

export const StatusTypography = styled(Typography)(({ theme }) => ({
	textAlign: "left",
	fontSize: "12px",
	paddingBottom: "4px",
	color: theme.palette.text.secondary,
}));

export const BoldTypography = styled("span")(() => ({
	fontWeight: "700",
}));
